// import Seo from "@/components/Seo/Seo";
import assest from "../../json/assest";
// import Wrapper from "@/layout/wrapper/Wrapper";
import {
  Box,
  Button,
  List,
  ListItem,
  MenuItem,
  Paper,
  Popover,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import styles from "../../styles/pages/purchasedrequest.module.scss";
import styles1 from "../../styles/pages/editors.module.scss";
// import Image from "next/image";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import CalenderIcon from "../../ui/Icons/CalenderIcon";
import { Link } from "react-router-dom";
import PrevIcon from "../../ui/Icons/PrevIcon";
import NextIcon from "../../ui/Icons/NextIcon";
import MessageDetails from "../../components/MessageDetails/MessageDetails";
import NotificationLeftFilter from "../../components/NotificationLeftFilter/NotificationLeftFilter";
import TabPanel from "../../components/UtilitiesComponent/TabPanel";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import Wrapper from "../../layout/wrapper/Wrapper";
import useFetch from "../../hooks/api/useFetch";
import {
  getMonthQueryRange,
  getMonthRange,
  getUtcDate,
  getUtcDateTime,
  getUtcTime,
  getYearRange,
} from "../../lib/functions/utils.lib";
import EmptyTable from "../../components/EmptyTable/EmptyTable";
import ApiLoader from "../../components/Loaders/ApiLoader";
import Pagination from "../../components/UtilitiesComponent/Pagination";

const buyerNotification = [
  {
    image: `${assest.notificationProfileImg}`,
    text: "Content Buyer sent you a message regarding a purchase request.",
    name: "Name: Philippe Martin",
    prid: "PRID: #153",
    rightnow: "Right now",
  },
  {
    image: `${assest.notificationProfileImg}`,
    text: "Content Buyer has requested a video purchase.",
    name: "Name: Philippe Martin",
    prid: "PRID: #153",
    rightnow: "Right now",
  },
  {
    image: `${assest.notificationProfileImg}`,
    text: "Content Buyer has confirmed the purchase of a video you approved.",
    name: "Name: Philippe Martin",
    prid: "PRID: #153",
    rightnow: "Right now",
  },
  {
    image: `${assest.notificationProfileImg}`,
    text: "Content Buyer has indicated that they haven’t purchased a video you approved.",
    name: "Name: Philippe Martin",
    prid: "PRID: #153",
    rightnow: "Right now",
  },
  {
    image: `${assest.notificationProfileImg}`,
    text: "Content Buyer has responded to your message regarding a purchase request.",
    name: "Name: Philippe Martin",
    prid: "PRID: #153",
    rightnow: "Right now",
  },
];

const rows = [
  {
    prid: "#1",
    video:
      "https://www.tiktok.com/@user2318560054981/video/7232623961731763462",
    request: (
      <>
        January 16, 2023 <br />
        at 07:53 AM UTC{" "}
      </>
    ),
    decision: "Pending",
    purchased: "-",
    type: "pending",
  },
  {
    prid: "#2",
    video: "https://www.tiktok.com/@user207577419559/video/7233068238165249286",
    request: (
      <>
        January 14, 2023 <br />
        at 10:22 PM UTC
      </>
    ),
    decision: "Approved",
    purchased: "Yes",
    type: "approved",
  },
  {
    prid: "#3",
    video: "https://vk.com/video-68471405_456343940",
    request: (
      <>
        January 16, 2023 <br />
        at 07:53 AM UTC{" "}
      </>
    ),
    decision: "Rejected",
    purchased: "No",
    type: "rejected",
  },
];

const PurchaseRequest = () => {
  const [status, setStatus] = React.useState("");
  const [month, setMonth] = React.useState("");
  const [year, setYear] = React.useState("");
  const [page, setPage] = React.useState(1);
  const [archive, setArchive] = React.useState(false);

  const handleArchiveToggle = () => {
    setArchive((prev) => !prev);
    setPage(1);
  };
  const handleChange1 = (event) => {
    setStatus(event.target.value);
  };
  const handleChange2 = (event) => {
    setMonth(event.target.value);
  };

  const handleChange3 = (event) => {
    setYear(event.target.value);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function getStartAndEndDate(monthName, year) {
    if (typeof monthName !== "undefined" && !isNaN(year)) {
      const startDate = new Date(year, monthName, 1);

      const endDate = new Date(year, monthName, 0);

      const startDateStr = `${startDate.getFullYear()}-${String(
        startDate.getMonth()
      ).padStart(2, "0")}-${String(startDate.getDate()).padStart(2, "0")}`;
      const endDateStr = `${endDate.getFullYear()}-${String(
        endDate.getMonth() + 1
      ).padStart(2, "0")}-${String(endDate.getDate()).padStart(2, "0")}`;

      return `&from=${startDateStr}&to=${endDateStr}`;
    } else {
      return null; // Invalid input
    }
  }

  const { data, isLoading, refetch, isSuccess, isRefetching } = useFetch(
    ["purchase-request", page, status, month, year, archive],
    `/admin/purchase/requests?page=${page}&status=${status}${archive ? "&archive=1" : "&archive=0"
    }${month && year ? getStartAndEndDate(month, year) : ""}`
  );


  const totalPages = data?.data?.meta?.last_page || 0;

  const handlePrevClick = () => {
    if (page > 1) {
      setPage(page - 1);
      refetch();
    }
  };

  const handleNextClick = () => {
    if (page < totalPages) {
      setPage(page + 1);
      refetch();
    }
  };

  return (
    <Wrapper>
      <ApiLoader loading={isLoading || isRefetching} />
      <Box className="main_body">
        <Box className={`commonBox ${styles.messageCommnBox}`}>
          <Stack
            direction="row"
            alignItems="center"
            flexWrap="wrap"
            className={styles.messageHeader}
          >
            <Select
              value={status}
              onChange={handleChange1}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                    borderRadius: "7px",
                    marginTop: "5px",

                    "& .MuiMenuItem-root": {
                      padding: 0,
                      fontSize: "11px",
                      fontWeight: "500",
                      color: "#525050",
                      lineHeight: "1",
                      "&:hover": {
                        backgroundColor: "#ffffff",
                        color: "#111ae9",
                      },
                      "&:not(:last-child)": {
                        marginBottom: "10px",
                      },
                    },
                    "& .Mui-selected": {
                      background: "#fff !important",
                    },

                    "& .MuiList-root": {
                      padding: "20px 14px",
                      minWidth: "134px",
                      height: "120px",
                    },
                  },
                },
              }}
            >
              <MenuItem value="">Message Status</MenuItem>
              <MenuItem value="">Need your reply</MenuItem>
              <MenuItem value={0}>Pending</MenuItem>
              <MenuItem value={1}>Resolved</MenuItem>
            </Select>
            <Box className={styles.creationDate}>
              <Button
                aria-describedby={id}
                variant="contained"
                onClick={handleClick}
                endIcon={<CalenderIcon />}
              >
                Creation Date
              </Button>
              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                PaperProps={{
                  sx: {
                    boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                    borderRadius: "7px",
                    marginTop: "5px",
                    padding: "24px",
                    maxWidth: "254px",
                    width: "100%",
                    "& .MuiTypography-caption": {
                      fontWeight: "500",
                      fontSize: "13px",
                      color: "#494949",
                      marginBottom: "8px",
                      display: "block",
                    },
                  },
                }}
              >
                <Typography variant="caption">Created in</Typography>
                <Stack
                  direction="row"
                  alignItems="center"
                  flexWrap="wrap"
                  className={styles.selectDate}
                >
                  <Select
                    value={month}
                    onChange={handleChange2}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                          borderRadius: "7px",
                          marginTop: "5px",

                          "& .MuiMenuItem-root": {
                            padding: 0,
                            fontSize: "11px",
                            fontWeight: "500",
                            color: "#525050",
                            lineHeight: "1",
                            "&:hover": {
                              backgroundColor: "#ffffff",
                              color: "#111ae9",
                            },
                            "&:not(:last-child)": {
                              marginBottom: "10px",
                            },
                          },
                          "& .Mui-selected": {
                            background: "#fff !important",
                          },

                          "& .MuiList-root": {
                            padding: "20px 14px",
                            height: "120px",
                          },
                        },
                      },
                    }}
                  >
                    <MenuItem value="">Month</MenuItem>
                    {getMonthRange().map((item, index) => (
                      <MenuItem value={item?.value} key={index}>
                        {item?.month}
                      </MenuItem>
                    ))}
                  </Select>
                  <Select
                    value={year}
                    onChange={handleChange3}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                          borderRadius: "7px",
                          marginTop: "5px",

                          "& .MuiMenuItem-root": {
                            padding: 0,
                            fontSize: "11px",
                            fontWeight: "500",
                            color: "#525050",
                            lineHeight: "1",
                            "&:hover": {
                              backgroundColor: "#ffffff",
                              color: "#111ae9",
                            },
                            "&:not(:last-child)": {
                              marginBottom: "10px",
                            },
                          },
                          "& .Mui-selected": {
                            background: "#fff !important",
                          },

                          "& .MuiList-root": {
                            padding: "20px 14px",
                            height: "120px",
                          },
                        },
                      },
                    }}
                  >
                    <MenuItem value="">Year</MenuItem>
                    {getYearRange().map((item, index) => (
                      <MenuItem value={item.value} key={index}>
                        {item.year}
                      </MenuItem>
                    ))}
                  </Select>
                </Stack>
              </Popover>
            </Box>
            <Button
              className={`${archive
                ? `${styles.btnArchive} ${styles.activeBtnArchive}`
                : `${styles.btnArchive}`
                }`}
              onClick={handleArchiveToggle}
            >
              Archive
            </Button>
          </Stack>

          <Box className={styles.tableResponsive}>
            <Box className={styles.purchasedTable}>
              <TableContainer component={Paper}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell className={styles.prid}>PRID</TableCell>
                      <TableCell className={styles.video}>Video URL</TableCell>
                      <TableCell className={styles.request}>
                        Request Date
                      </TableCell>
                      <TableCell className={styles.decision}>
                        Decision
                      </TableCell>
                      <TableCell className={styles.purchased}>
                        Purchased?
                      </TableCell>
                      <TableCell align="center" className={styles.view}>
                        View
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  {data?.data?.data?.length > 0 ? (
                    <>
                      <TableBody>
                        {data?.data?.data?.map((row, index) => (
                          <>
                            <TableRow key={index}>
                              <TableCell scope="row">
                                #{row?.id}
                              </TableCell>
                              <TableCell>
                                <Typography variant="body1">
                                  <Link to={row?.video_url} target="_blank">
                                    {row?.video_url}
                                  </Link>
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Typography variant="body1">
                                  {getUtcDate(row.created)} <br />
                                  {getUtcTime(row.created)}
                                </Typography>
                              </TableCell>
                              <TableCell
                                className={`${row.type === "noneed"
                                    ? `${styles.noNeed} ${styles.statusTxt}`
                                    : row.status === 4
                                      ? `${styles.removed} ${styles.statusTxt}`
                                      : row.status === 0
                                        ? `${styles.pending} ${styles.statusTxt}`
                                        : row.status === 1
                                          ? `${styles.approved} ${styles.statusTxt}`
                                          : row.status === 2
                                            ? `${styles.rejected} ${styles.statusTxt}`
                                            : styles.statusTxt
                                  }`}
                              >
                                <Typography variant="body2">
                                  {row?.status === 0
                                    ? "Pending"
                                    : row?.status === 1
                                      ? "Approved"
                                      : row?.status === 2
                                        ? "Rejected"
                                        : row?.status === 4
                                          ? "Removed"
                                          : ""}
                                </Typography>
                              </TableCell>
                              <TableCell
                                scope="row"
                                className={styles.purchedtable}
                              >
                                <Box className={styles.purchasedTxt}>
                                  {row?.purchased === 0 ? (
                                    "-"
                                  ) : row?.purchased === 1 ? (
                                    <Box className={styles.purchaseTxtBox}>
                                      <p>Yes</p>
                                      <p>
                                        {" "}
                                        {row?.video?.vsid
                                          ? `VSID:#${row?.video?.vsid}`
                                          : ""}
                                      </p>
                                    </Box>
                                  ) : row?.purchased === 2 ? (
                                    "No"
                                  ) : (
                                    ""
                                  )}
                                </Box>
                              </TableCell>
                              <TableCell align="center">
                                <Link to={`/request-details/${row?.id}`}>
                                  <img
                                    src={assest.IconView}
                                    width={16}
                                    height={16}
                                    alt="icon"
                                  />
                                </Link>
                              </TableCell>
                            </TableRow>

                            <TableRow key={row.id} className={styles.blnkTd}>
                              <TableCell colSpan={6}>{""}</TableCell>
                            </TableRow>
                          </>
                        ))}
                      </TableBody>
                    </>
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} className={styles.emptyTableRow}>
                        <EmptyTable
                          emptyTableText={
                            "You have no purchase requests at the moment. Please reload the page or check back later."
                          }
                        />
                      </TableCell>
                    </TableRow>
                  )}
                </Table>
              </TableContainer>
            </Box>
            {data?.data?.meta?.total > 0 ? (
              <Stack
                direction="row"
                flexWrap="wrap"
                alignItems="center"
                className="btnPagination"
              >
                <Button
                  startIcon={<PrevIcon />}
                  onClick={handlePrevClick}
                  disabled={page === 1}
                >
                  Prev
                </Button>
                <Button
                  endIcon={<NextIcon />}
                  onClick={handleNextClick}
                  disabled={page === totalPages}
                >
                  Next
                </Button>
              </Stack>
            ) : null}
          </Box>
        </Box>

        {/*  <Box className={`commonBox ${styles.messageCommnBox}`}>
          <MessageDetails />
        </Box> */}

        {/*  <Box className={`commonBox ${styles.messageCommnBox}`}>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            className={styles1.editorBody}
          >
            <Box className={styles1.SecFilter}>
              <NotificationLeftFilter filterType={"notification"} />
            </Box>

            <Box className={styles1.purchasedNotification}>
              <Box className={styles.purchasedNotificationTabFull}>
                <Box className={styles.purchasedNotificationTabBar}>
                  <Box className={styles.purchasedNotificationTab}>
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      aria-label="basic tabs example"
                    >
                      <Tab label="All Notifications" />
                      <Tab label="Archive" />
                    </Tabs>
                  </Box>

                  <Box className={styles.markArchive}>
                    <List>
                      <ListItem>
                        <img
                          src={assest.markReadIcon}
                          width={16}
                          height={8}
                          alt=""
                        />{" "}
                        Mark all as read
                      </ListItem>
                      <ListItem>
                        <img
                          src={assest.archiveIcon}
                          width={15}
                          height={18}
                          alt=""
                        />{" "}
                        Archive all
                      </ListItem>
                    </List>
                  </Box>
                </Box>
                <TabPanel value={value} index={0}>
                  <Box className={styles.tabDetails}>
                    <PerfectScrollbar>
                      {buyerNotification.map((item, index) => {
                        return (
                          <Box className={styles.notificationItem}>
                            <Box className={styles.notificationText}>
                              <Box className={styles.notificationImg}>
                                <img
                                  src={item.image}
                                  width={26}
                                  height={25}
                                  alt=""
                                />
                              </Box>
                              <Box className={styles.notificationDetailsTxt}>
                                <h4>{item.text}</h4>
                                <h5>{item.name}</h5>
                                <h5>{item.prid}</h5>
                                <p>{item.rightnow}</p>
                              </Box>
                            </Box>

                            <Box className={styles.notificationButton}>
                              <Button>View</Button>
                              <Button>Mark as read</Button>
                            </Box>
                          </Box>
                        );
                      })}
                    </PerfectScrollbar>
                  </Box>
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <Box className={styles.tabDetails}>
                    <PerfectScrollbar>
                      {buyerNotification.map((item, index) => {
                        return (
                          <Box className={styles.notificationItem}>
                            <Box className={styles.notificationText}>
                              <Box className={styles.notificationImg}>
                                <img
                                  src={item.image}
                                  width={26}
                                  height={25}
                                  alt=""
                                />
                              </Box>
                              <Box className={styles.notificationDetailsTxt}>
                                <h4>{item.text}</h4>
                                <h5>{item.name}</h5>
                                <h5>{item.prid}</h5>
                                <p>{item.rightnow}</p>
                              </Box>
                            </Box>

                            <Box className={styles.notificationButton}>
                              <Button>View</Button>
                              <Button>Mark as read</Button>
                            </Box>
                          </Box>
                        );
                      })}
                    </PerfectScrollbar>
                  </Box>
                </TabPanel>
              </Box>
            </Box>
          </Stack>
        </Box> */}
      </Box>
    </Wrapper>
  );
};

export default PurchaseRequest;
